import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'

import styles from './Legend.css'

export default (
  <ul className={styles.legend}>
    <li>
      <SvgIcon icon="run" className={styles.run} />
      {'Run build'}
    </li>
    <li>
      <span className={styles.unrelated} />
      {'Unrelated'}
    </li>
    <li>
      <span className={styles.circle} />
      <SvgIcon icon="stack" className={styles.stack} />
      {'Several builds'}
    </li>
    <li>
      <span className={styles.selected} />
      {'Selected'}
    </li>
    <li>
      <span className={styles.reused} />
      {'Reused'}
    </li>
  </ul>
)
